// @flow
import { useContext } from 'react';

import { EstimateContext } from '../contexts/EstimateContext';

// The backend sends these package bounds only for a CC Starter Commit (Launch / Launch Pro) estimate,
// so their absence means the estimate isn't on a starter package and no package limit applies.
export const getStarterCommitLimits = (estimate) => estimate?.starter_commit_limits ?? null;

export const useStarterCommitLimits = () => {
  const estimate = useContext(EstimateContext);
  return getStarterCommitLimits(estimate);
};
